import React, {useEffect} from 'react';
import {BuutonMenuLateralAA} from './BuutonMenuLateralAA';
import './menuLateralAA.css';
import {useSessionStore} from '../../hooks/useSessionStore';
import {UsuarioContext} from '../../contexts/UsuarioContext';
import {useNavigate} from 'react-router-dom';
import axios from 'axios';
/* A function that returns a JSX element. */
export const MenuLateralAB = (props) => {
	/* Destructuring the props object. */
	const {seleccionado, MenuLateralAux, chageMenuLateralAux} = props;
	const [Usuario, setUsuario] = useSessionStore(UsuarioContext);

	/* A hook that allows to navigate between routes. */
	const navigate = useNavigate();

	const cerrarSesion = () => {
		if (Usuario.tipo === 'usuarioAdmin') {
			navigate('/loginAdmin');
		} else {
			navigate('/login');
		}
		setUsuario({
			tipo: 'noRegistrado',
			userName: '',
			email: '',
			imagen: '',
			access: '',
			refresh: '',
		});
	};

	/* An array of objects. */
	let listaBotonesMenuLateralAA = [
		{
			nombre: 'Mi empresa',
			clase: 'buttonMenuLateralAA',
			goTo: 'miEmpresa',
			icon: (
				<svg
					xmlns='http://www.w3.org/2000/svg'
					width='25'
					height='25'
					fill='currentColor'
					className='bi bi-briefcase'
					viewBox='0 0 16 16'
				>
					<path d='M6.5 1A1.5 1.5 0 0 0 5 2.5V3H1.5A1.5 1.5 0 0 0 0 4.5v8A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-8A1.5 1.5 0 0 0 14.5 3H11v-.5A1.5 1.5 0 0 0 9.5 1h-3zm0 1h3a.5.5 0 0 1 .5.5V3H6v-.5a.5.5 0 0 1 .5-.5zm1.886 6.914L15 7.151V12.5a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5V7.15l6.614 1.764a1.5 1.5 0 0 0 .772 0zM1.5 4h13a.5.5 0 0 1 .5.5v1.616L8.129 7.948a.5.5 0 0 1-.258 0L1 6.116V4.5a.5.5 0 0 1 .5-.5z' />
				</svg>
			),
			tipo: 'empresa',
		},
		{
			nombre: 'Agenda',
			clase: 'buttonMenuLateralAA',
			goTo: 'presupuestos',
			icon: (
				<svg
					xmlns='http://www.w3.org/2000/svg'
					width='25'
					height='25'
					fill='currentColor'
					className='bi bi-card-checklist'
					viewBox='0 0 16 16'
				>
					<path d='M14.5 3a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h13zm-13-1A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2h-13z' />
					<path d='M7 5.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm-1.496-.854a.5.5 0 0 1 0 .708l-1.5 1.5a.5.5 0 0 1-.708 0l-.5-.5a.5.5 0 1 1 .708-.708l.146.147 1.146-1.147a.5.5 0 0 1 .708 0zM7 9.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm-1.496-.854a.5.5 0 0 1 0 .708l-1.5 1.5a.5.5 0 0 1-.708 0l-.5-.5a.5.5 0 0 1 .708-.708l.146.147 1.146-1.147a.5.5 0 0 1 .708 0z' />
				</svg>
			),
			tipo: 'empresa',
		},
		{
			nombre: 'Calendario',
			clase: 'buttonMenuLateralAA',
			goTo: 'calendarios',
			icon: (
				<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line></svg>
			),
			tipo: 'empresa',
		},
		{
			nombre: 'Documentos',
			clase: 'buttonMenuLateralAA',
			goTo: 'misDocumentos',
			icon: (
				<svg
					xmlns='http://www.w3.org/2000/svg'
					width='25'
					height='25'
					fill='currentColor'
					class='bi bi-filetype-pdf'
					viewBox='0 0 16 16'
				>
					<path
						fill-rule='evenodd'
						d='M14 4.5V14a2 2 0 0 1-2 2h-1v-1h1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5L14 4.5ZM1.6 11.85H0v3.999h.791v-1.342h.803c.287 0 .531-.057.732-.173.203-.117.358-.275.463-.474a1.42 1.42 0 0 0 .161-.677c0-.25-.053-.476-.158-.677a1.176 1.176 0 0 0-.46-.477c-.2-.12-.443-.179-.732-.179Zm.545 1.333a.795.795 0 0 1-.085.38.574.574 0 0 1-.238.241.794.794 0 0 1-.375.082H.788V12.48h.66c.218 0 .389.06.512.181.123.122.185.296.185.522Zm1.217-1.333v3.999h1.46c.401 0 .734-.08.998-.237a1.45 1.45 0 0 0 .595-.689c.13-.3.196-.662.196-1.084 0-.42-.065-.778-.196-1.075a1.426 1.426 0 0 0-.589-.68c-.264-.156-.599-.234-1.005-.234H3.362Zm.791.645h.563c.248 0 .45.05.609.152a.89.89 0 0 1 .354.454c.079.201.118.452.118.753a2.3 2.3 0 0 1-.068.592 1.14 1.14 0 0 1-.196.422.8.8 0 0 1-.334.252 1.298 1.298 0 0 1-.483.082h-.563v-2.707Zm3.743 1.763v1.591h-.79V11.85h2.548v.653H7.896v1.117h1.606v.638H7.896Z'
					/>
				</svg>
			),
			tipo: 'empresa',
		},
		{
			nombre: 'Categorías y servicios',
			clase: 'buttonMenuLateralAA',
			goTo: 'misCategorias',
			icon: (
				<svg
					xmlns='http://www.w3.org/2000/svg'
					width='25'
					height='25'
					fill='currentColor'
					className='bi bi-grid'
					viewBox='0 0 16 16'
				>
					<path d='M1 2.5A1.5 1.5 0 0 1 2.5 1h3A1.5 1.5 0 0 1 7 2.5v3A1.5 1.5 0 0 1 5.5 7h-3A1.5 1.5 0 0 1 1 5.5v-3zM2.5 2a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-3zm6.5.5A1.5 1.5 0 0 1 10.5 1h3A1.5 1.5 0 0 1 15 2.5v3A1.5 1.5 0 0 1 13.5 7h-3A1.5 1.5 0 0 1 9 5.5v-3zm1.5-.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-3zM1 10.5A1.5 1.5 0 0 1 2.5 9h3A1.5 1.5 0 0 1 7 10.5v3A1.5 1.5 0 0 1 5.5 15h-3A1.5 1.5 0 0 1 1 13.5v-3zm1.5-.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-3zm6.5.5A1.5 1.5 0 0 1 10.5 9h3a1.5 1.5 0 0 1 1.5 1.5v3a1.5 1.5 0 0 1-1.5 1.5h-3A1.5 1.5 0 0 1 9 13.5v-3zm1.5-.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-3z' />
				</svg>
			),
			tipo: 'empresa',
		},
		{
			nombre: 'Mi Plan',
			clase: 'buttonMenuLateralAA',
			goTo: 'miPlan',
			icon: (
				<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="20" x2="12" y2="10"></line><line x1="18" y1="20" x2="18" y2="4"></line><line x1="6" y1="20" x2="6" y2="16"></line></svg>
			),
			tipo: 'empresa',
		},
		/*
        {
            nombre: "Historial de facturación", clase: "buttonMenuLateralAA", goTo: "historialFacturas",
            icon:
                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" className="bi bi-file-earmark-ruled" viewBox="0 0 16 16">
                    <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V9H3V2a1 1 0 0 1 1-1h5.5v2zM3 12v-2h2v2H3zm0 1h2v2H4a1 1 0 0 1-1-1v-1zm3 2v-2h7v1a1 1 0 0 1-1 1H6zm7-3H6v-2h7v2z" />
                </svg>,
            tipo: "empresa"
        },
        */
		/*
    {
        nombre: "Servicio de Informes", clase: "buttonMenuLateralAA", goTo: "generarInformes", icon:
            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" className="bi bi-file-earmark-arrow-down-fill" viewBox="0 0 16 16">
                <path d="M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zm-1 4v3.793l1.146-1.147a.5.5 0 0 1 .708.708l-2 2a.5.5 0 0 1-.708 0l-2-2a.5.5 0 0 1 .708-.708L7.5 11.293V7.5a.5.5 0 0 1 1 0z" />
            </svg>,
        tipo: "empresa"
        ,
    },

        */
		/*************************************************/
		/***********  PARTE DEL ADMINISTRADOR ************/
		/*************************************************/

		{
			nombre: 'Usuarios',
			clase: 'buttonMenuLateralAA',
			goTo: 'Usuarios',
			icon: (
				<svg
					xmlns='http://www.w3.org/2000/svg'
					width='25'
					height='25'
					fill='currentColor'
					className='bi bi-person-lines-fill'
					viewBox='0 0 16 16'
				>
					<path d='M6 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-5 6s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H1zM11 3.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5zm.5 2.5a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1h-4zm2 3a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1h-2zm0 3a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1h-2z' />
				</svg>
			),
			tipo: 'admin',
		},
		{
			nombre: 'Generar Informes',
			clase: 'buttonMenuLateralAA',
			goTo: 'graficas',
			icon: (
				<svg
					xmlns='http://www.w3.org/2000/svg'
					width='25'
					height='25'
					fill='currentColor'
					className='bi bi-pie-chart-fill'
					viewBox='0 0 16 16'
				>
					<path d='M15.985 8.5H8.207l-5.5 5.5a8 8 0 0 0 13.277-5.5zM2 13.292A8 8 0 0 1 7.5.015v7.778l-5.5 5.5zM8.5.015V7.5h7.485A8.001 8.001 0 0 0 8.5.015z' />
				</svg>
			),
			tipo: 'admin',
		},
		{
			nombre: 'Empresas',
			clase: 'buttonMenuLateralAA',
			goTo: 'empresas',
			icon: (
				<svg
					xmlns='http://www.w3.org/2000/svg'
					width='25'
					height='25'
					fill='currentColor'
					className='bi bi-briefcase'
					viewBox='0 0 16 16'
				>
					<path d='M6.5 1A1.5 1.5 0 0 0 5 2.5V3H1.5A1.5 1.5 0 0 0 0 4.5v8A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-8A1.5 1.5 0 0 0 14.5 3H11v-.5A1.5 1.5 0 0 0 9.5 1h-3zm0 1h3a.5.5 0 0 1 .5.5V3H6v-.5a.5.5 0 0 1 .5-.5zm1.886 6.914L15 7.151V12.5a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5V7.15l6.614 1.764a1.5 1.5 0 0 0 .772 0zM1.5 4h13a.5.5 0 0 1 .5.5v1.616L8.129 7.948a.5.5 0 0 1-.258 0L1 6.116V4.5a.5.5 0 0 1 .5-.5z' />
				</svg>
			),
			tipo: 'admin',
		},
		{
			nombre: 'Categorías y servicios',
			clase: 'buttonMenuLateralAA',
			goTo: 'categoriasServicios',
			icon: (
				<svg
					xmlns='http://www.w3.org/2000/svg'
					width='25'
					height='25'
					fill='currentColor'
					className='bi bi-grid'
					viewBox='0 0 16 16'
				>
					<path d='M1 2.5A1.5 1.5 0 0 1 2.5 1h3A1.5 1.5 0 0 1 7 2.5v3A1.5 1.5 0 0 1 5.5 7h-3A1.5 1.5 0 0 1 1 5.5v-3zM2.5 2a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-3zm6.5.5A1.5 1.5 0 0 1 10.5 1h3A1.5 1.5 0 0 1 15 2.5v3A1.5 1.5 0 0 1 13.5 7h-3A1.5 1.5 0 0 1 9 5.5v-3zm1.5-.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-3zM1 10.5A1.5 1.5 0 0 1 2.5 9h3A1.5 1.5 0 0 1 7 10.5v3A1.5 1.5 0 0 1 5.5 15h-3A1.5 1.5 0 0 1 1 13.5v-3zm1.5-.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-3zm6.5.5A1.5 1.5 0 0 1 10.5 9h3a1.5 1.5 0 0 1 1.5 1.5v3a1.5 1.5 0 0 1-1.5 1.5h-3A1.5 1.5 0 0 1 9 13.5v-3zm1.5-.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-3z' />
				</svg>
			),
			tipo: 'admin',
		},
		{
			nombre: 'Tus pacientes',
			clase: 'buttonMenuLateralAA',
			goTo: 'pacientes',
			icon: (
				<svg
					xmlns='http://www.w3.org/2000/svg'
					width='25'
					height='25'
					fill='currentColor'
					className='bi bi-person-video2'
					viewBox='0 0 16 16'
				>
					<path d='M10 9.05a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z' />
					<path d='M2 1a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2H2ZM1 3a1 1 0 0 1 1-1h2v2H1V3Zm4 10V2h9a1 1 0 0 1 1 1v9c0 .285-.12.543-.31.725C14.15 11.494 12.822 10 10 10c-3.037 0-4.345 1.73-4.798 3H5Zm-4-2h3v2H2a1 1 0 0 1-1-1v-1Zm3-1H1V8h3v2Zm0-3H1V5h3v2Z' />
				</svg>
			),
			tipo: 'admin',
		},

		/*************************************************/
		/***********  PARTE DEL ADMINISTRADOR ************/

		{
			nombre: 'Mi perfil',
			clase: 'buttonMenuLateralAA',
			goTo: 'miPerfil',
			icon: (
				<svg
					xmlns='http://www.w3.org/2000/svg'
					width='25'
					height='25'
					fill='currentColor'
					className='bi bi-person'
					viewBox='0 0 16 16'
				>
					<path d='M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4Zm-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10Z' />
				</svg>
			),
			tipo: 'cliente',
		},
		{
			nombre: 'Monitor de servicios',
			clase: 'buttonMenuLateralAA',
			goTo: 'monitorCuidados',
			icon: (
				<svg
					xmlns='http://www.w3.org/2000/svg'
					width='20'
					height='20'
					fill='currentColor'
					className='bi bi-heart-pulse'
					viewBox='0 0 16 16'
				>
					<path d='m8 2.748-.717-.737C5.6.281 2.514.878 1.4 3.053.918 3.995.78 5.323 1.508 7H.43c-2.128-5.697 4.165-8.83 7.394-5.857.06.055.119.112.176.171a3.12 3.12 0 0 1 .176-.17c3.23-2.974 9.522.159 7.394 5.856h-1.078c.728-1.677.59-3.005.108-3.947C13.486.878 10.4.28 8.717 2.01L8 2.748ZM2.212 10h1.315C4.593 11.183 6.05 12.458 8 13.795c1.949-1.337 3.407-2.612 4.473-3.795h1.315c-1.265 1.566-3.14 3.25-5.788 5-2.648-1.75-4.523-3.434-5.788-5Z' />
					<path d='M10.464 3.314a.5.5 0 0 0-.945.049L7.921 8.956 6.464 5.314a.5.5 0 0 0-.88-.091L3.732 8H.5a.5.5 0 0 0 0 1H4a.5.5 0 0 0 .416-.223l1.473-2.209 1.647 4.118a.5.5 0 0 0 .945-.049l1.598-5.593 1.457 3.642A.5.5 0 0 0 12 9h3.5a.5.5 0 0 0 0-1h-3.162l-1.874-4.686Z' />
				</svg>
			),
			tipo: 'cliente',
		},
		{
			nombre: 'Usuarios',
			clase: 'buttonMenuLateralAA',
			goTo: 'misPacientes',
			icon: (
				<svg
					xmlns='http://www.w3.org/2000/svg'
					width='20'
					height='20'
					fill='currentColor'
					className='bi bi-person-rolodex'
					viewBox='0 0 16 16'
				>
					<path d='M8 9.05a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z' />
					<path d='M1 1a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h.5a.5.5 0 0 0 .5-.5.5.5 0 0 1 1 0 .5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5.5.5 0 0 1 1 0 .5.5 0 0 0 .5.5h.5a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H6.707L6 1.293A1 1 0 0 0 5.293 1H1Zm0 1h4.293L6 2.707A1 1 0 0 0 6.707 3H15v10h-.085a1.5 1.5 0 0 0-2.4-.63C11.885 11.223 10.554 10 8 10c-2.555 0-3.886 1.224-4.514 2.37a1.5 1.5 0 0 0-2.4.63H1V2Z' />
				</svg>
			),
			tipo: 'cliente',
		},
		{
			nombre: 'Cerrar sesión',
			clase: 'buttonMenuLateralAA',
			goTo: '',
			icon: (
				<svg
					xmlns='http://www.w3.org/2000/svg'
					width='25'
					height='25'
					fill='currentColor'
					className='bi bi-box-arrow-left'
					viewBox='0 0 16 16'
				>
					<path
						fillRule='evenodd'
						d='M6 12.5a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5h-8a.5.5 0 0 0-.5.5v2a.5.5 0 0 1-1 0v-2A1.5 1.5 0 0 1 6.5 2h8A1.5 1.5 0 0 1 16 3.5v9a1.5 1.5 0 0 1-1.5 1.5h-8A1.5 1.5 0 0 1 5 12.5v-2a.5.5 0 0 1 1 0v2z'
					/>
					<path
						fillRule='evenodd'
						d='M.146 8.354a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L1.707 7.5H10.5a.5.5 0 0 1 0 1H1.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3z'
					/>
				</svg>
			),
			tipo: 'todos',
		},
		{
			nombre: 'Inicio',
			clase: 'buttonMenuLateralAA',
			goTo: '',
			icon: (
				<svg
					xmlns='http://www.w3.org/2000/svg'
					width='25'
					height='25'
					fill='currentColor'
					className='bi bi-house'
					viewBox='0 0 16 16'
				>
					<path d='M8.707 1.5a1 1 0 0 0-1.414 0L.646 8.146a.5.5 0 0 0 .708.708L2 8.207V13.5A1.5 1.5 0 0 0 3.5 15h9a1.5 1.5 0 0 0 1.5-1.5V8.207l.646.647a.5.5 0 0 0 .708-.708L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293L8.707 1.5ZM13 7.207V13.5a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5V7.207l5-5 5 5Z' />
				</svg>
			),
			tipo: 'cliente',
		},
	];
	const getImagenPerfil = () => {
		let tipo = '';
		if (Usuario.tipo === 'usuarioNormal') {
			tipo = 'imagenPerfilCliente/';
		} else if (Usuario.tipo === 'usuarioEmpresa') {
			tipo = 'imagenPerfilEmpresa/';
		}
		axios({
			method: 'get',
			url: window.ipdirection + tipo,
			headers: {
				Authorization: 'Bearer ' + Usuario.access,
			},
		})
			.then((response) => {
				if (response.data.length > 0) {
					axios({
						method: 'get',
						url: window.ipdirection + tipo + response.data[0].id.toString() + '/',
						headers: {
							Authorization: 'Bearer ' + Usuario.access,
						},
						responseType: 'blob',
					})
						.then((response2) => {
							setUsuario({
								...Usuario,
								fotoPerfil: URL.createObjectURL(response2.data),
							});
						})
						.catch((error) => {
							setUsuario({
								...Usuario,
								fotoPerfil:
									'https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fwww.omgtb.com%2Fwp-content%2Fuploads%2F2021%2F04%2F620_NC4xNjE-768x768.jpg&f=1&nofb=1&ipt=6e70641a1d064ed7a25e8f5428a004d5f8b720a9ae21a2028f48a538530174b2&ipo=images',
							});
							console.log(error);
						});
				}
			})
			.catch((error) => {
				console.log(error);
			});
	};

	useEffect(() => {
		if (Usuario.tipo !== 'noRegistrado'){
			getImagenPerfil();
		}
	}, []);

	/* A function that returns a JSX element. */
	return (
		<div
			className={
				Usuario.tipo !== 'noRegistrado' && MenuLateralAux === undefined
					? 'none'
					: Usuario.tipo !== 'noRegistrado' && MenuLateralAux
					  ? 'base-menuLateralAA'
					  : 'base-menuLateralAA--oculto'
			}
			onClick={() => {
				Usuario.tipo !== 'noRegistrado' && MenuLateralAux === true && chageMenuLateralAux();
			}}
		>
			<div
				className={
					MenuLateralAux === undefined
						? 'none'
						: MenuLateralAux
						  ? 'menuLateralAA'
						  : 'menuLateralAA--oculto'
				}
			>
				<div>
					{
						<div
							className='imagen-nombre-perfil-menuLateral'
							onClick={() => {
								Usuario.tipo === 'usuarioNormal'
									? navigate('/miPerfil')
									: Usuario.tipo === 'usuarioEmpresa' && navigate('/miEmpresa');
							}}
						>
							<img src={Usuario.fotoPerfil} alt={Usuario.email} />
							<div className='nombre-perfil-menuLateral'>
								{Usuario.tipo === 'usuarioNormal'
									? Usuario.cliente.nombre
									: Usuario.tipo === 'usuarioEmpresa' &&
									  Usuario.prestadorServicios.nombreEmpresa}
							</div>
						</div>
					}
					{listaBotonesMenuLateralAA.map((botonMenuLateralAA, key) =>
						(
							<>
								{botonMenuLateralAA.nombre === 'Mi perfil' && (
									<div className='centrador'>
										<div className='separador' />
									</div>
								)}
								{botonMenuLateralAA.nombre === 'Inicio' && (
									<div className='centrador'>
										<div className='separador' />
									</div>
								)}
							</>
						) &&
						Usuario.tipo === 'usuarioEmpresa' &&
						botonMenuLateralAA.tipo === 'empresa' ? (
							key === seleccionado ? (
								<BuutonMenuLateralAA
									key={key}
									opcion={botonMenuLateralAA.nombre}
									stilo={'buttonMenuLateralAAClick'}
									goTo={botonMenuLateralAA.goTo}
									icon={botonMenuLateralAA.icon}
									chageMenuLateralAux={chageMenuLateralAux}
									MenuLateralAux={MenuLateralAux}
								/>
							) : (
								<BuutonMenuLateralAA
									key={key}
									opcion={botonMenuLateralAA.nombre}
									stilo={botonMenuLateralAA.clase}
									goTo={botonMenuLateralAA.goTo}
									icon={botonMenuLateralAA.icon}
									chageMenuLateralAux={chageMenuLateralAux}
									MenuLateralAux={MenuLateralAux}
								/>
							)
						) : Usuario.tipo === 'usuarioAdmin' &&
						  botonMenuLateralAA.tipo === 'admin' ? (
							key === seleccionado ? (
								<BuutonMenuLateralAA
									key={key}
									opcion={botonMenuLateralAA.nombre}
									stilo={' buttonMenuLateralAAClick'}
									goTo={botonMenuLateralAA.goTo}
									icon={botonMenuLateralAA.icon}
									chageMenuLateralAux={chageMenuLateralAux}
									MenuLateralAux={MenuLateralAux}
								/>
							) : (
								<BuutonMenuLateralAA
									key={key}
									opcion={botonMenuLateralAA.nombre}
									stilo={botonMenuLateralAA.clase}
									goTo={botonMenuLateralAA.goTo}
									icon={botonMenuLateralAA.icon}
									chageMenuLateralAux={chageMenuLateralAux}
									MenuLateralAux={MenuLateralAux}
								/>
							)
						) : Usuario.tipo === 'usuarioNormal' &&
						  botonMenuLateralAA.tipo === 'cliente' ? (
							key === seleccionado ? (
								<BuutonMenuLateralAA
									key={key}
									chageMenuLateralAux={chageMenuLateralAux}
									MenuLateralAux={MenuLateralAux}
									opcion={botonMenuLateralAA.nombre}
									stilo={' buttonMenuLateralAAClick'}
									goTo={botonMenuLateralAA.goTo}
									icon={botonMenuLateralAA.icon}
								/>
							) : (
								<BuutonMenuLateralAA
									key={key}
									opcion={botonMenuLateralAA.nombre}
									chageMenuLateralAux={chageMenuLateralAux}
									MenuLateralAux={MenuLateralAux}
									stilo={botonMenuLateralAA.clase}
									goTo={botonMenuLateralAA.goTo}
									icon={botonMenuLateralAA.icon}
								/>
							)
						) : null
					)}
				</div>
				{listaBotonesMenuLateralAA.map(
					(botonMenuLateralAA, key) =>
						Usuario.tipo !== 'noRegistrado' &&
						botonMenuLateralAA.tipo === 'todos' && (
							<div className='button-cerrar-sesion'>
								<div
									className='buttonMenuLateralAA'
									onClick={() => {
										cerrarSesion();
									}}
								>
									<div className='textMenuLateralAA'>
										{botonMenuLateralAA.icon !== undefined && (
											<div className='centrador'>
												{botonMenuLateralAA.icon}
											</div>
										)}
										<div className='centradorLeft'>
											{botonMenuLateralAA.nombre}
										</div>
									</div>
								</div>
							</div>
						)
				)}
			</div>
		</div>
	);
};
